import { Observable, of, Subject } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SuscriptionService } from '@core/services';
import { SchoolPeriodSlot } from '@shared/models';

@Component({
  selector: 'app-subscribe-radial-options',
  templateUrl: './subscribe-radial-options.component.html',
  styleUrls: ['./subscribe-radial-options.component.scss'],
})
export class SubscribeRadialOptionsComponent {
  private refreshSubject = new Subject<void>();
  loading: boolean = false;
  schoolPeriodSlots$: Observable<SchoolPeriodSlot[]> = this.refreshSubject.asObservable().pipe(
    tap(() => (this.loading = true)),
    switchMap(() => this.getSchoolPeriodSlots()),
    tap(() => (this.loading = false))
  );

  constructor(
    private suscriptionService: SuscriptionService,
    private dataService: DataService,
    private router: Router
  ) {}

  ionViewDidEnter() {
    this.refreshSubject.next();
  }

  private getSchoolPeriodSlots(): Observable<SchoolPeriodSlot[]> {
    return this.suscriptionService.getSchoolPeriodSlots().pipe(catchError(() => of(null)));
  }

  goSubscribe(schoolPeriodSlot: SchoolPeriodSlot) {
    let suscription = this.dataService.getData('subscription');
    suscription = { ...suscription, slot_id: schoolPeriodSlot.id, slot_name: schoolPeriodSlot.name };
    this.dataService.setData('subscription', suscription);
    this.router.navigate(['/tecservice-transportec/subscription/subscribe-radial']);
  }
}
